import LABEL from '../../../business-const/Label/Label'

import ClienteService from '../../../business-api/ClienteService'

import {
    pesquisaList,
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import perfilList from '../../../business-rules/List/perfilList'

import {
    equipeListSelecao,
} from '../../configuracao/ConfiguracaoServiceEquipeFormEquipe'



export const equipeListCompartilhamento = ( variaveisGlobais, values, id, perfil, jsonConfiguracao, equipeList ) => {

    let equipePerfilList

    if (jsonConfiguracao.compartilhamentoPerfilUsuario && jsonConfiguracao.compartilhamentoPerfilUsuario.length > 0) {

        equipePerfilList =
            jsonConfiguracao.compartilhamentoPerfilUsuario.filter(
                linhaCompartilhamentoPerfilUsuario => linhaCompartilhamentoPerfilUsuario.perfil === perfil)

    } else {

        equipePerfilList = equipeList
    }

    let equipeListCompartilhamentoAux = []

    equipeList?.forEach( (linhaEquipeList, index) => {

        if (
                (
                    pesquisaList(equipePerfilList, linhaEquipeList.id).id &&
                    linhaEquipeList.id !== ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais)
                ) ||
                id === linhaEquipeList.id) {

            equipeListCompartilhamentoAux.push(
                linhaEquipeList
            )
        }
    })

    return equipeListSelecao(id, equipeListCompartilhamentoAux, false, values.compartilhamentoUsuario, jsonConfiguracao, false)
}



export const exibeCompartilhamentoUsuario = (id, equipeList, jsonConfiguracao) => {

    const linhaEquipeList = pesquisaList(equipeList, id)

    return '<b>' + linhaEquipeList.identificacao + '</b>' + LABEL.traco + pesquisaDescricaoList(perfilList, linhaEquipeList.perfil) +
        (linhaEquipeList.filialUnidade
            ?
                LABEL.traco + pesquisaDescricaoList(jsonConfiguracao.filiaisUnidades, linhaEquipeList.filialUnidade)
            : 
                ''
        )
}